import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BenefitSliderListItem } from '../shared/benefitSliderListItem';
import { CardWidget } from '../../../lib/components/compound/surfaces/cardWidget';
import { BenefitIcon } from '../../../lib/components/compound/dataDisplay';
import { BenefitWishesActiveDashboardWidgetProps, ICON_PROPS } from '../shared';
import { ScrollableList } from '../shared/scrollableList';
import { Loading } from '../../../lib/components';

type Props = BenefitWishesActiveDashboardWidgetProps;

export const BenefitActivatedDashboardWidget: FC<Props> = ({ isLoading, stats }) => {
  const { t } = useTranslation();

  return (
    <CardWidget
      title={t('common:BENEFIT_ACTIVE_TITLE')}
      subTitle={t('common:BENEFIT_ACTIVE_SUBTITLE')}
    >
      {isLoading ? (
        <Loading />
      ) : (
        <ScrollableList>
          {stats &&
            stats.map((benefit, index) => (
              <BenefitSliderListItem
                key={index}
                icon={<BenefitIcon benefitKey={benefit.key} {...ICON_PROPS} />}
                title={t(`benefits:${benefit.key}`)}
                percent={Math.round(benefit.active_percent)}
              />
            ))}
        </ScrollableList>
      )}
    </CardWidget>
  );
};
